const parseHTMLAndExtractImages = html => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const imgElements = doc.querySelectorAll('img')
    const srcArray = Array.from(imgElements).map(img => img.src)
    return srcArray
}

export default parseHTMLAndExtractImages